"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledInternalSummary = exports.StyledFormSummary = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _base = _interopRequireDefault(require("../../../style/themes/base"));

var _icon = _interopRequireDefault(require("../../icon/icon.style"));

var _button = _interopRequireDefault(require("../../button/button.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StyledFormSummary = _styledComponents.default.div`
  display: inline-flex;
  align-items: center;
  font-size: 13px;
  font-weight: 700;
  margin: -8px;
  padding: 8px;
  white-space: nowrap;

  ${({
  showSummary,
  theme
}) => showSummary && (0, _styledComponents.css)`
      background-color: ${theme.form.invalid};
    `}

  ${_button.default} {
    margin-right: 0;
  }
`;
exports.StyledFormSummary = StyledFormSummary;
const StyledInternalSummary = _styledComponents.default.div`
  display: flex;
  align-items: center;
  margin-right: 16px;
  ${({
  type,
  theme
}) => type === "warnings" && (0, _styledComponents.css)`
      color: ${theme.colors.warning};
    `}
  ${({
  type,
  theme
}) => type === "errors" && (0, _styledComponents.css)`
      color: ${theme.colors.error};
    `}

  &:first-of-type {
    margin-left: 4px;
  }

  ${_icon.default} {
    margin-right: 4px;
    ${({
  type,
  theme
}) => type === "warnings" && (0, _styledComponents.css)`
        color: ${theme.colors.warning};
      `}
    ${({
  type,
  theme
}) => type === "errors" && (0, _styledComponents.css)`
        color: ${theme.colors.error};
      `}
  }
`;
exports.StyledInternalSummary = StyledInternalSummary;
StyledFormSummary.propTypes = {
  theme: _propTypes.default.object,
  showSummary: _propTypes.default.bool
};
StyledFormSummary.defaultProps = {
  theme: _base.default
};
StyledInternalSummary.propTypes = {
  theme: _propTypes.default.object,
  type: _propTypes.default.oneOf(["errors", "warnings"])
};
StyledInternalSummary.defaultProps = {
  theme: _base.default
};